// zod configuration for the browser build, imported first by main.tsx so it runs before any
// schema parses. The deployed CSP has no 'unsafe-eval' (ADR-0021): zod's one-time probe for
// `new Function` would be blocked and reported as a securitypolicyviolation, and zod would fall
// back to its interpreter anyway. `jitless` skips the probe and uses the interpreter from the
// start. Tests and scripts do not import this module.
import { z } from 'zod';

z.config({ jitless: true });
